import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { NewProductPage } from '../../../features/catalog/product-pages'
import {
  attributesQueryOptions,
  categoriesQueryOptions,
  unitsQueryOptions,
} from '../../../features/catalog/queries'
import { taxRatesQueryOptions } from '../../../features/finance/queries'

export const Route = createFileRoute('/_app/products/new')({
  staticData: { crumb: 'productNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'products.create'),
  loader: ({ context }) => {
    // Warm the pickers; the form does not wait for them.
    void context.queryClient.prefetchQuery(unitsQueryOptions)
    void context.queryClient.prefetchQuery(categoriesQueryOptions)
    void context.queryClient.prefetchQuery(attributesQueryOptions)
    void context.queryClient.prefetchQuery(taxRatesQueryOptions)
  },
  component: NewProductPage,
})
